import type { FaireProductEntity } from "../../entity_types/product";

export const p_554s5t8jjd: FaireProductEntity = {
  token: "p_554s5t8jjd",
  type: "product",
  name: "Her Life Stages Perimenopause",
  brandToken: "b_jbqfywxgpa",
  brandName: "Solaray",
  imageUrl:
    "https://cdn.faire.com/fastly/2e20d51192f5e8bb54e8d268bee2a39193f78399c30002812f18f7d745b6b0e9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a11654b3509335c8aad2bc2cf8bdfc5a50db6710dd10e3af8f209cc56ba66260.jpeg",
    "https://cdn.faire.com/fastly/65d5604b9472af6d6fe1f14c9567a81920ea3dc0d5dcbe1fd4c3441903e8ede5.png",
  ],
  priceDollars: 22.2,
  description:
    "* A blend of powerful ingredients that support a healthy cycle, including ones to help ease breast tenderness, plus support a positive outlook†* \n * With black cohosh to support perimenopausal hot flashes and night sweats and to help promote sound sleep‡* \n * Features chasteberry for PMS and breast tenderness support and affron® saffron for mood and sleep support—no hormones or soy* \n * Includes iodine for thyroid support and Chromax® chromium to support healthy glucose metabolism* \n * Plus a trace mineral complex to help maintain overall wellness*\nDoctor-formulated using scientifically backed ingredients for a perimenopause solution you can rely on \n * 2X award winner: Taste for Life Supplement Essentials for Women’s Health and NEXTY Awards Best New Condition-Specific Supplement\n\n† As experienced in conjunction with a normal, healthy period.\n‡ As experienced in conjunction with perimenopause.\n\nNot sure which formula is right for you? Take our quick STAGES Quiz for a tailored product recommendation.",
  tags: [],
  msrpDollars: 38.69,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:16.391Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
